import { SupportRequestReason } from '@/app/entities/SupportRequest'

import { httpClient } from '../http/httpClient'
import {
  SupportAttendanceDay,
  SupportAttendanceStatsParams,
} from './getSupportAttendanceStats'

export interface SupportOverviewMember {
  id: string
  name: string
  attended: number
  open: number
  inProgress: number
}

export interface SupportOverviewStatsResponse {
  from: string
  to: string
  days: SupportAttendanceDay[]
  indicators: {
    opened: number
    attended: number
    averageAttended: number
    attendants: number
    openNow: number
    inProgressNow: number
    unassignedNow: number
  }
  ranking: SupportOverviewMember[]
  reasons: { reason: SupportRequestReason; count: number }[]
}

export interface SupportOverviewStatsParams extends SupportAttendanceStatsParams {
  members?: string[]
}

export async function getSupportOverviewStats({
  members,
  ...params
}: SupportOverviewStatsParams = {}) {
  const { data } = await httpClient.get<SupportOverviewStatsResponse>(
    '/support-requests/stats/overview',
    {
      params: {
        ...params,
        ...(members?.length && { members: members.join(',') }),
      },
    },
  )

  return data
}
